import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/components/ads/ramp-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TermlyCMP"] */ "/app/apps/web/components/advertising/termly-cmp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppFooter"] */ "/app/apps/web/components/app-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppHeaderContent"] */ "/app/apps/web/components/app-header-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntercomContainer"] */ "/app/apps/web/components/intercom.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/app/apps/web/lib/app-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GooglePublisherTagsProvider"] */ "/app/apps/web/providers/google-publisher-tags-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MetadataProvider"] */ "/app/apps/web/providers/metadata-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"styles/fonts/index.ts\",\"import\":\"Inter\",\"arguments\":[{\"display\":\"swap\",\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"variable\":\"--fontInter\",\"weight\":[\"400\",\"500\"]}],\"variableName\":\"fontInter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"styles/fonts/index.ts\",\"import\":\"Barlow\",\"arguments\":[{\"display\":\"swap\",\"subsets\":[\"latin\"],\"variable\":\"--fontBarlow\",\"weight\":[\"400\",\"500\"]}],\"variableName\":\"fontBarlow\"}");
;
import(/* webpackMode: "eager" */ "/app/apps/web/styles/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/app/packages/ui/components/ui/tooltip.tsx");
